<style lang="scss" scoped>
// @import 'common/sass/reuse.SCSS';
.handle {
  margin: 25px;
  .trades {
    margin-left: 20px;
  }
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  width: 50%;
}
.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

/deep/ .el-drawer__body {
  overflow-y: auto;
}
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="trades">
          <el-button type="primary" class="handle-row" icon="el-icon-circle-plus" @click="configWindow = true">{{ language.addBtnTxt }}</el-button>
        </el-col>
      </el-row>
      <el-row v-loading="configLoading">
        <el-table :data="confListPaging" border>
          <template v-for="(v, i) in language.accHead">
            <el-table-column :label="v.value" :key="i">
              <template slot-scope="scope">
                <el-input v-if="v.writable" type="textarea" maxlength="255" v-model="scope.row[v.key]"></el-input>
                <span v-else>{{ scope.row[v.key] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column :label="language.lastTableColumnTxt" width="120px">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" circle @click="deletePositionConfig(scope.row.id)"></el-button>
              <el-button type="primary" icon="el-icon-edit" circle @click="updateAccount(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- 新增自动报仓配置 -->
    <el-dialog :title="language.addDialogTitle" :visible.sync="configWindow" :before-close="(done) => {}" :show-close="false">
      <el-form :model="confForm" :rules="rules" ref="confForm" label-position="top">
        <el-form-item>
            <span slot="label">
                {{language.confValLabelOpt.confType}}
                <el-tooltip effect="light" placement="bottom-start">
                    <div slot="content">
                        <el-row v-for="(k, v) in language.descContent" :key="v">{{k}}</el-row>
                    </div>
                    <i class="el-icon-question"></i>
                </el-tooltip>
            </span>
            <el-select v-model="confKey" :placeholder="language.formSelectDefaultTxt" @change="handleConfKeyChange">
                <el-option v-for="(k, v) in language.confKeyOpt" :disabled="disabledKeys.includes(v)" :key="v" :label="k" :value="v"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="confKey !== 'specialSecurity'" :label="language.confValLabelOpt[confKey]" :prop="confKey">
            <el-input v-model.number="confForm[confKey]"></el-input>
        </el-form-item>
        <template v-if="confKey === 'manager'">
            <el-form-item :label="language.confValLabelOpt.tittle" prop="tittle">
                <el-input v-model="confForm.tittle"></el-input>
            </el-form-item>
            <el-form-item :label="language.confValLabelOpt.conv" prop="conv">
                <el-input v-model="confForm.conv"></el-input>
            </el-form-item>
        </template>
        <template v-if="confKey === 'security'">
            <el-form-item :label="language.confValLabelOpt.types" prop="types">
                <!-- <el-select v-model="confForm.types" multiple filterable :placeholder="language.formSelectDefaultTxt">
                    <el-option v-for="item in securityList" :disabled="!specialSecurityCanSelect.every(v => v.TYPE !== item.TYPE)" :key="item.TYPE" :label="item.TYPE" :value="item.TYPE"></el-option>
                </el-select> -->
                <el-cascader 
                    v-model="confForm.types" 
                    :placeholder="language.formSelectDefaultTxt" 
                    :options="securityList" 
                    :props="{ multiple: true, checkStrictly: true }"
                    filterable
                    clearable>
                </el-cascader>
            </el-form-item>
            <el-form-item :label="language.confValLabelOpt.abandonedRange" prop="abandonedRange">
                <el-col :span="11">
                    <el-slider v-model="confForm.abandonedMin" show-input :min="-5000" :max="0"></el-slider>
                </el-col>
                <el-col :span="2">&nbsp;</el-col>
                <el-col :span="11">
                    <el-slider v-model="confForm.abandonedMax" show-input :min="0" :max="5000"></el-slider>
                </el-col>
            </el-form-item>
        </template>
        <template v-if="confKey === 'specialSecurity'">
            <el-form-item :label="language.confValLabelOpt.specialSymbol" prop="specialSymbol">
                <el-select v-model="confForm.specialSymbol" multiple filterable :placeholder="language.formSelectDefaultTxt">
                    <el-option v-for="item in symbolList" :key="item.SYMBOL" :label="item.SYMBOL" :value="item.SYMBOL"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="language.confValLabelOpt.specialSecurity" prop="specialSecurity">
                <el-select v-model="confForm.specialSecurity" filterable  :placeholder="language.formSelectDefaultTxt">
                    <el-option v-for="item in specialSecurityCanSelect" :key="item.TYPE" :label="item.TYPE" :value="item.TYPE"></el-option>
                </el-select>
            </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetFilledConfig">{{ language.formCancelTxt }}</el-button>
        <el-button type="primary" @click="addPositionConfig">{{ language.formConfirmTxt }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { 
    URL_SECURITY, 
    URL_SYMBOL_LIST,
    URL_ADDORUPDATE_POSITION_CONFIG,
    URL_DELETE_POSITION_CONFIG,
    URL_GET_POSITION_CONFIG
} from 'api/api'
const data = () => {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confKey: 'security',
        confForm: {
            minutes: null,
            showMaxCount:null,
            manager: null,
            security: null,
            tittle: null,
            types: [],
            abandonedMax: 0,
            abandonedMin: 0,
            specialSymbol: [],
            specialSecurity: '',
            conv: null,
        },
        symbolList: [],
        securityList: [],
        disabledKeys: [],
        updateID: null,
        specialSecurityCanSelect: [],

        pageNum: 1,
        pageSize: 5,
        total: 0,
    }
}

const mixins = [
    require('common/mixin/base').base({ language: 'autoPositionReport' }), 
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
    tableHead() {
        return this.language.tableHead
    },
    rules() {
        const language = this.language;
        const rules = {
            minutes: [
                { required: true, message: language.miutesRulesRequired, trigger: 'blur' },
                { type: 'number', message: language.miutesRulesNumber, trigger: 'blur' }
            ],
            manager: [
                { required: true, message: language.managerRulesRequired, trigger: 'blur' },
                { type: 'number', message: language.managerRulesNumber, trigger: 'blur' }
            ],
            security: [
                { required: true, message: language.securityRulesRequired, trigger: 'blur' },
            ],
            showMaxCount: [
                { required: true, message: language.maxCountRulesRequired, trigger: 'blur' },
                { type: 'number', message: language.maxCountRulesNumber, trigger: 'blur' }
            ],
            types: [
                { required: true, message: language.typeRulesRequired, trigger: 'blur' },
            ],
            specialSymbol: [
                { 
                    required: true, 
                    validator: (rule, value, callback) => {
                        if(value.length || this.updateID) callback()
                        else callback(language.specialSymbolRulesRequired)
                    }, 
                    trigger: 'change' 
                },
                // { required: true, message: language.specialSymbolRulesRequired, trigger: 'change' },
            ],
            specialSecurity: [
                { required: true, message: language.specialSecurityRulesRequired, trigger: 'blur' }
            ]
        }
        return rules
    },
}

const created = function () {
    Promise.all([this.$http.get(URL_SYMBOL_LIST), this.$http.get(URL_SECURITY)]).then(res => {
        const [symbolRes, securityRes] = res
        this.symbolList = symbolRes.data.data

        const obj = {}
        securityRes.data.data.forEach(v => {
            const paths = v.TYPE.split('\\')
            this.parsePath(obj, paths)
        })
        Object.keys(obj).forEach(k => {
            const type = { value: k, label: k }
            this.convToArray(type, obj[k])
            this.securityList.push(type);
        })
    })
    this.getPositionConfig()
}

const methods = {
    addPositionConfig() {
        this.$refs['confForm'].validate((valid) => {
            if (valid) {
                const modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name
                const confKey = this.confKey
                const addObj = {
                    modifyBy, 
                    confKey
                }
                let confValue = '', formObj = this.confForm
                if(confKey === 'minutes') confValue = formObj.minutes
                if(confKey === 'manager') {
                    const tittle = formObj.tittle || ''
                    if(formObj.conv) confValue = `{"${formObj.manager}":{"tittle":"${tittle}","conv": ${formObj.conv}}}`
                    else confValue = `{"${formObj.manager}":"${tittle}"}`
                }
                if(confKey === 'security') {
                    const typesStr = formObj.types.reduce((p, c) => {
                        if(p === "") return `"${c}"`
                        return `${p},"${c}"`
                    }, "")
                    confValue = `{"${formObj.security}":{"types":[${typesStr}], "abandonedMax": ${formObj.abandonedMax},"abandonedMin": ${formObj.abandonedMin}}}`
                }
                if(confKey === 'showMaxCount') confValue = formObj.showMaxCount
                if(confKey === 'specialSecurity') {
                    const specialSymbolStr = formObj.specialSymbol.reduce((p, c) => {
                        if(p === "") return `"${c}"`
                        return `${p},"${c}"`
                    }, "")
                    confValue = `{"${formObj.specialSecurity.replace(/\\/g,',')}":[${specialSymbolStr}]}`
                }
                addObj.confValue = confValue
                const addConfig = this.updateID === null
                const successKey = addConfig ? 'addSuccess' : 'updateSuccess'
                const failedKey = addConfig ? 'addFailed' : 'updateFailed'
                !addConfig && Object.assign(addObj, { id: this.updateID })

                this.$http.post(URL_ADDORUPDATE_POSITION_CONFIG, addObj).then((res) => {
                    const code = res.data.data
                    if (code === 9000) this.$message({ message: this.language[successKey], type: 'success' })
                    else this.$message({ message: this.language[failedKey], type: 'error' })
                    this.getPositionConfig()
                    this.resetFilledConfig()
                })
            }
        })
    },
    getPositionConfig() {
        this.configLoading = true
        this.specialSecurityCanSelect = []
        this.$http.get(URL_GET_POSITION_CONFIG).then((res) => {
            const result = res.data.data
            this.confList = result.data
            this.confList.forEach(val => {
                const confKey = val.conf_key
                val.conf_desc = this.language.confKeyOpt[confKey]
                if (confKey === 'security') val.types.forEach(type => this.specialSecurityCanSelect.push({ TYPE: type.replace(/,/g,'\\') }))
                if (confKey === 'specialSecurity') val[confKey] = val[confKey].replace(/,/g, '\\');
                if (confKey === 'manager' && Object.prototype.toString.call(val.tittle) === '[object Object]') {
                    val.conv = val.tittle.conv
                    val.tittle = val.tittle.tittle
                }
                val.value = val[confKey]
            })
            this.total = this.confList.length
            this.disabledKeys = result.disabledKeys
            this.slicData()
            this.configLoading = false
        })
    },
    updateAccount(row) {
        const confKey = row.conf_key;
        this.confKey = confKey;
        Object.keys(this.confForm).forEach(k => this.confForm[k] = row[k])
        this.updateID = row.id;
        this.configWindow = true;
    },
    deletePositionConfig(id) {
        const lg = this.language
        this.$confirm(`${lg.deleteMsgTxt}`, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(() => {
            this.$http.delete(URL_DELETE_POSITION_CONFIG, { params: { id } }).then((res) => {
                const code = res.data.data
                if (code == 9000) {
                    this.$message({ message: lg.delSuccess, type: 'success' })
                    // 第N页删除后页码需要减一
                    const countAfterDelete = this.total - 1
                    if(countAfterDelete % this.pageSize === 0) this.pageNum -= countAfterDelete / this.pageSize
                    this.getPositionConfig()
                } else {
                    this.$message({ message: lg.delFailed, type: 'info' })
                }
            })
        })
    },
    resetFilledConfig() {
        this.configWindow = false
        setTimeout(() => {
            this.confKey = 'security'
            this.handleConfKeyChange()
        }, 100)
    },
    handlePageChange(val) {
        this.pageNum = val
        this.slicData()
    },
    handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.confListPaging = this.confList.slice(0, this.pageSize)
    },
    handleConfKeyChange(val) {
        this.resetFields()
        this.updateID = null
        this.$refs['confForm'].clearValidate()
    },
    resetFields() {
        ['minutes', 'showMaxCount', 'manager', 'security', 'tittle', 'conv'].forEach(k => this.confForm[k] = null);
        ['types','specialSymbol'].forEach(k => this.confForm[k] = []);
        ['abandonedMax','abandonedMin'].forEach(k => this.confForm[k] = 0);
        this.confForm.specialSecurity = '';
    },
    slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize)
    },
    parsePath(obj, paths){
        if (!paths.length) return
        const path = paths[0]
        if (!obj[path]) obj[path] = {}
        paths.shift()
        this.parsePath(obj[path], paths)
    },
    convToArray (type, obj) {
        const keys = Object.keys(obj);
        if (!keys.length) return;
        type.children = [];
        keys.forEach(k => {
            const t = { value: k, label: k }
            this.convToArray(t, obj[k])
            type.children.push(t);
        })
    }
}

const watch = {
  language() {
    this.confListPaging.forEach(val => val.conf_desc = this.language.confKeyOpt[val.conf_key])
  }
}

export default {
    data,
    mixins,
    computed,
    created,
    methods,
    watch
}
</script>


// WEBPACK FOOTER //
// src/views/report/auto-position-report.vue